const TopAssistsTypes = {
    GET_TOP_ASSISTS_START:'GET_TOP_ASSISTS_START',
    GET_TOP_ASSISTS_SUCCESS:'GET_TOP_ASSISTS_SUCCESS',
    GET_TOP_ASSISTS_FAILED:'GET_TOP_ASSISTS_FAILED',

}

export default TopAssistsTypes